import Vue from "vue";
import VueI18n from "vue-i18n";
import lang_en from "element-ui/lib/locale/lang/en";
import lang_cn from "element-ui/lib/locale/lang/zh-CN";
import lang_hk from "element-ui/lib/locale/lang/zh-TW";
import locale from "element-ui/lib/locale";
import zhCN from "vxe-pc-ui/lib/language/zh-CN"; // 中文(简体)
import zhHK from "vxe-pc-ui/lib/language/zh-HK"; // 中文(香港)
import enUS from "vxe-pc-ui/lib/language/en-US"; // 英文(美国)
import { VxeUI } from "vxe-pc-ui";

//esaytable
import easyTable_en from "vue-easytable/libs/locale/lang/en-US.js";
import easyTable_cn from "vue-easytable/libs/locale/lang/zh-CN.js";
import easyTable_hk from "vue-easytable/libs/locale/lang/zh-TW.js";
import { VeLocale } from "vue-easytable";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: window.localStorage.getItem("lang") ? window.localStorage.getItem("lang") : "CN",
  messages: {
    CN: require("../assets/common/lang/CN.js"),
    EN: require("../assets/common/lang/EN.js"),
    HK: require("../assets/common/lang/HK.js"),
  },
});

if (window.localStorage.getItem("lang") == "EN") {
  locale.use(lang_en);
  VeLocale.use(easyTable_en);
  VxeUI.setI18n("en-US", enUS);
  VxeUI.setLanguage("en-US");
} else if (window.localStorage.getItem("lang") == "HK") {
  locale.use(lang_hk);
  VeLocale.use(easyTable_hk);
  VxeUI.setI18n("zh-HK", zhHK);
  VxeUI.setLanguage("zh-HK");
} else {
  locale.use(lang_cn);
  VeLocale.use(easyTable_cn);
  VxeUI.setI18n("zh-CN", zhCN);
    VxeUI.setLanguage("zh-CN");
}

export default i18n;
